import Config from '../Config';
import axios from 'axios';

export async function checkTaxNumber(data) {
    const { taxNumber, dateOfBirth } = data;

    const apiPath = `/public/resource/${taxNumber}/check-tax-number`;

    const request = {
        url: `https://${Config.DYNAMO_API_URL}${apiPath}`,
        // url: `http://localhost:3001${apiPath}`,
        host: Config.DYNAMO_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        body: JSON.stringify({ birthDate: dateOfBirth }),
        data: { birthDate: dateOfBirth },
        headers: {
            'Content-Type': 'application/json',
        },
        validateStatus: () => true,
    };
    const response = await axios(request);

    return response;
}